var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-card-title", { staticClass: "soli-grey" }, [
        _vm._v(_vm._s(_vm.results.length) + " Results"),
      ]),
      _vm._v(" "),
      _c(
        "v-list",
        { attrs: { dense: "" } },
        _vm._l(_vm.results, function (result) {
          return _c("v-list-item", { key: result.id }, [_vm._v(_vm._s(result))])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }